import normalHearingIcon from './normal.png';
import mildHearingIcon from './mild.png';
import moderateHearingIcon from './moderate.png';
import legatoLogoMaroon from './legato-logo-maroon.webp';
import legatoLogoOrange from './legato-logo.webp';
export var legatoImages = {
    normalHearingIcon: normalHearingIcon,
    mildHearingIcon: mildHearingIcon,
    moderateHearingIcon: moderateHearingIcon,
    legatoLogoMaroon: legatoLogoMaroon,
    legatoLogoOrange: legatoLogoOrange,
};
